/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Template000Data,
  Template001Data,
  Template002Data,
  Template003Data,
  Template004Data,
  OpenButtonData,
  ButtonPosition,
  TemplateStyle,
} from './TemplateData';

import template001_data1000_img1 from '@/assets/img/template001_data1000_img1.png';
import template002_data2000_img1 from '@/assets/img/template002_data2000_img1.svg';
import template003_data3000_img1 from '@/assets/img/template003_data3000_img1.svg';
import template003_data3000_img2 from '@/assets/img/template003_data3000_img2.svg';
import template003_data3000_img3 from '@/assets/img/template003_data3000_img3.png';
import template003_data3000_img4 from '@/assets/img/template003_data3000_img4.jpg';

import template004_data4000_img1 from '@/assets/img/template004_data4000_img1.svg';
import template004_data4000_img2 from '@/assets/img/template004_data4000_img2.svg';
import template004_data4000_img3 from '@/assets/img/template004_data4000_img3.png';
import template004_data4000_img4 from '@/assets/img/template004_data4000_img4.png';
import i18n from '@/i18n';

const defaultOpenButton: OpenButtonData = {
  content: i18n.global.t('common.openWpsExperience'),
  width: '280px',
  height: '48px',
  text_color: '#ffffff',
  text_size: '16px',
  bg_color: '#3B64FC',
  position: ButtonPosition.BOTTOM,
  offset: '50px',
  radius: '18px',
};

const aiOpenButton: OpenButtonData = {
  content: i18n.global.t('common.claimNow'),
  width: '280px',
  height: '48px',
  text_color: '#ffffff',
  text_size: '16px',
  bg_color: 'linear-gradient(90deg, #93b8ff, #777bfb, #5154ff, #895cf4, #f65ef0)',
  position: ButtonPosition.BOTTOM,
  offset: '102px',
  radius: '32px',
};

const dataMap = new Map([
  [getDefaultViewKey(), new Template000Data(defaultOpenButton)],
  [
    '1000',
    new Template001Data(
      i18n.global.t('template.t001.title'),
      '#EF5A4D',
      template001_data1000_img1,
      i18n.global.t('template.t001.introduction'),
      [
        i18n.global.t('template.t001.desc1'),
        i18n.global.t('template.t001.desc2'),
        i18n.global.t('template.t001.desc3'),
      ],
      defaultOpenButton,
    ),
  ],
  ['2000', new Template002Data(template002_data2000_img1, defaultOpenButton)],
  [
    '3000',
    new Template003Data(
      template003_data3000_img1,
      template003_data3000_img2,
      template003_data3000_img3,
      template003_data3000_img4,
      defaultOpenButton,
    ),
  ],
  [
    '4000',
    new Template004Data(
      template004_data4000_img1,
      template004_data4000_img2,
      template004_data4000_img3,
      template004_data4000_img4,
      aiOpenButton,
    ),
  ],
]);

function getPageDescByKey(view_key: string) {
  if (dataMap.has(view_key)) {
    const templateData = dataMap.get(view_key);
    return templateData?.page_desc;
  }
  return undefined;
}

function getDefaultViewKey() {
  return '0';
}

function getViewDataByKey(key: string) {
  let realKey = key;
  if (!dataMap.has(realKey)) {
    realKey = getDefaultViewKey();
  }
  return dataMap.get(realKey);
}

function getTemplateStyle(key: string): TemplateStyle {
  let realKey = key;
  if (!dataMap.has(realKey)) {
    realKey = getDefaultViewKey();
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const templateData: any = dataMap.get(realKey);
  if (templateData instanceof Template000Data) {
    return TemplateStyle.TemplateStyle000;
  } else if (templateData instanceof Template001Data) {
    return TemplateStyle.TemplateStyle001;
  } else if (templateData instanceof Template002Data) {
    return TemplateStyle.TemplateStyle002;
  } else if (templateData instanceof Template003Data) {
    return TemplateStyle.TemplateStyle003;
  } else if (templateData instanceof Template004Data) {
    return TemplateStyle.TemplateStyle004;
  }
  return TemplateStyle.TemplateStyle000;
}

function getButtonDataByKey(key: string): OpenButtonData {
  let realKey = key;
  if (!dataMap.has(realKey)) {
    realKey = getDefaultViewKey();
  }
  const templateData: any = dataMap.get(realKey);
  return templateData.open_button;
}

export default {
  getPageDescByKey,
  getViewDataByKey,
  getTemplateStyle,
  getDefaultViewKey,
  getButtonDataByKey,
};
